import * as React from "react";
import { MDXProvider } from "@mdx-js/react";
import { Global, css } from "@emotion/core";
import { Document, Frame } from "@joeybright/compose";
import Helmet from "react-helmet";

const globalStyles = css`
  * {
    box-sizing: border-box;
  }
  body {
    padding: 0;
    margin: 0;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
      Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji",
      "Segoe UI Symbol";
  }
  #___gatsby,
  #___gatsby > div,
  html,
  body.compose-body,
  #gatsby-focus-wrapper > div {
    height: 100%;
  }
`;

const shortcodes = { Document, Frame };

const Layout = props => {
  return (
    <div>
      <Helmet
        bodyAttributes={{
          class: "compose-body"
        }}
      />
      <Global styles={globalStyles} />
      <MDXProvider components={shortcodes}>{props.children}</MDXProvider>
    </div>
  );
};

export default Layout;
